export default "__VITE_ASSET__DLxDWq2W__"